import type { JSX } from 'react';
import type { HearingLossExaminationData } from '@common/validation/customControls/hearingLoss/hearingLossExamination/hearingLossExamination';
import { AlertCheckbox } from '@frontend/components/pages/episodeCategory/customControls/AlertCheckbox';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';

export function PatientConsentCheckbox(): JSX.Element {
    const { data, errors } = useProcessActivityEditContext<HearingLossExaminationData>();
    const { onChange } = useEditFormSectionInputFieldContext();

    return (
        <AlertCheckbox
            checked={data.toestemming_van_patient ?? false}
            hasError={errors.has('toestemming_van_patient')}
            onChange={(checked) => onChange(checked)}
            text="Patiënt geeft toestemming voor het delen van persoonlijke en medische gegevens tussen Ksyos, audicien en eigen huisarts*"
            title="Toestemming van de patiënt"
            titleDanger="Geef alsjeblieft eerst aan of de patiënt toestemming geeft"
        />
    );
}
